import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M0 4a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#25F4EE",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.2",
      d: "M11.5 3.5v6c1.5.5 3-1 3-1",
      opacity: ".85"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#FE2C55",
      "stroke-linecap": "round",
      "stroke-width": "2.2",
      d: "M8.5 16.5a3.5 3.5 0 1 1 0-7",
      opacity: ".85"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#010101",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M14.5 7.5q-1.5 1-3 1v-5c.667 0 2 1 3 1 .667 0 1.5-.333 2-1M11.5 8.5V13A3.5 3.5 0 1 1 8 9.5"
    }, null, -1)
  ]))]))
}
export default { render: render }